import { type ReactNode } from 'react';
import classnames from 'classnames';

interface ContentAsideProps {
  className?: string | null;
  children: ReactNode;
}

const ContentAside = ({ className = null, children }: ContentAsideProps) => (
  <aside className={classnames('content__aside', className)}>{children}</aside>
);

export default ContentAside;
